import React from "react";
import "./intro.css";
// import Introimg from "../../assets/p-2.png";
// import Hireimg from "../../assets/hirebtn.gif";


import { TypeAnimation } from 'react-type-animation';

const Introimg= "https://res.cloudinary.com/dmnpdzcvd/image/upload/v1744653001/p-2_pwlog2.png";
const Hireimg = "https://res.cloudinary.com/dmnpdzcvd/image/upload/v1744655814/hirebtn_hyqbur.gif";

const Intro = () => {

  return (
    <section id="intro">
      <div className="intro-content">
        <span classname="hello">Hello,</span>
        <span className="introText">
          I'm
          <span className="introname"> Abid</span>
        </span>

        <TypeAnimation
      sequence={[
        // Same substring at the start will only be typed out once, initially
        'Jr.DEVELOPER.',
        1000, 
        'PORGRAMMER',
        1000,
        'CODER' ,
        1000
        
      ]}
      className="positions"
      wrapper="span"
      speed={50}
      style={{ display: 'inline-block' }}
      repeat={Infinity}
    />

        <p className="intropara" data-aos="fade-up"
     data-aos-duration="1000" >
          🔰 I am a skilled web Developer & programmer, with experience in
          creating visually appealing and user-friendly websites.
        </p>

        <button className="hire-btn" to='contact' spy={true} onClick={() => {
      document.getElementById('contact').scrollIntoView({behavior: 'smooth'});
    }} >
            <img src={Hireimg} alt="hire" className="hireimg" />
            HireMe!
          </button>
        
      </div>

      


      <img src={Introimg} alt="profile" className="intro-img" data-aos="fade-left"
     data-aos-duration="1000" />
    </section>
  );
};
export default Intro;

